import { render, staticRenderFns } from "./ScreeningRemainingTasksList.vue?vue&type=template&id=0ab4924c&"
import script from "./ScreeningRemainingTasksList.vue?vue&type=script&lang=js&"
export * from "./ScreeningRemainingTasksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports